import React, { useState } from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import Search from "./Search";
import InventoryList from "./InventoryList";
import SnackbarMessage from "../../../components/SnackbarMessage";
import { INVENTORY, SEARCH_INVENTORY } from "../../../constants/string";
import { useWarehouse } from "../../../contexts/WarehouseContext";

const Inventory = () => {
  const theme = useTheme();
  const [view, setView] = useState(0);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const { warehouseId } = useWarehouse();

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setView(newView);
    }
  };

  const handleOpenSnackBar = (message, severity) => {
    setShowSnackBar(true);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
  };

  const handleCloseSnackBar = () => {
    setShowSnackBar(false);
  };

  return (
    <Box
      style={{
        height: "calc(100% - 70px)",
        overflow: "auto",
        paddingBottom: "70px",
        background: theme.palette.background.main,
      }}
    >
      {view === 0 && (
        <InventoryList
          warehouseId={warehouseId}
          openSnackBar={handleOpenSnackBar}
        />
      )}
      {view === 1 && <Search />}

      <Box
        sx={{
          position: "fixed",
          bottom: isSmallScreen ? 55 : 0,
          width: "100%",
          textAlign: "center",
          backgroundColor: "white",
          boxShadow: "0px -2px 5px rgba(0, 0, 0, 0.2)",
          zIndex: 2,
        }}
      >
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={handleViewChange}
          aria-label="view selector"
          color="primary"
          fullWidth
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            //mb: 1,
          }}
        >
          {/* Inventory Button */}
          <ToggleButton
            value={0}
            aria-label="existing"
            sx={{
              marginLeft:1,
              marginTop:1,
              marginBottom:1,
              textTransform: "none",
              color: view === 0 ? "white" : "black",
              backgroundColor: view === 0 ? "#3f51b5" : "white",
              borderColor:"#0141ac",
              borderTopLeftRadius: 5,
              borderBottomLeftRadius: 5,
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0,
              boxShadow: 4,
              borderWidth: "1.5px",
              padding: "8px 16px",
              transition: "background-color 0.3s, color 0.3s",
            }}
          >
            {INVENTORY}
          </ToggleButton>

          {/* Search Inventory Button */}
          <ToggleButton
            value={1}
            aria-label="addNew"
            sx={{
              marginRight:1,
              marginTop:1,
              marginBottom:1,
              textTransform: "none",
              color: view === 1 ? "white" : "black",
              backgroundColor: view === 1 ? "#3f51b5" : "white",
              borderRadius:2,
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderTopRightRadius: 5,
              borderBottomRightRadius: 5,
              borderColor:"#0141ac",
              borderWidth: "1.5px",
              boxShadow: 2,
              padding: "8px 16px",
              transition: "background-color 0.3s, color 0.3s",
            }}
          >
            {SEARCH_INVENTORY}
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <SnackbarMessage
        open={showSnackBar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleCloseSnackBar}
      />
    </Box>
  );
};

export default Inventory;
